import { careersEn } from './careers-en'

export default {
  ...careersEn,
  nav: {
    home: 'HOME',
    about: 'ABOUT',
    rd: 'R&D',
    innovation: 'Innovation',
    pipelineStrategy: 'Pipeline & Strategy',
    science: 'Science',
    expandedAccess: 'Expanded Access Policy',
    pipeline: 'Pipeline',
    disease: 'Disease Areas',
    strategy: 'Strategy',
    news: 'NEWS',
    careers: 'CAREERS',
    detail: 'Job Detail',
    contact: 'CONTACT',
    ir: 'Investors',
    annoucement: 'Annoucement',
    presentation: 'Presentation',
    irContact: 'IR Contact',
    governance: 'Governance',
    stock: 'Stock'
  },
  ir: {
    AoA: 'Articles of Association',
    interim: 'Interim Notice',
    periodic: 'Periodic Notice'
  },
  ir_contact: {
    name: 'IR Department',
    addr: '199 Liangjing Rd, Zhangjiang Hi-Tech Park, Pudong District, Shanghai, China, 201203',
    tel: '+86-21-61095757',
    email: 'IR@dizalpharma.com'
  },
  core_value: {
    name: 'Core Value',
    value1: 'World-class innovation',
    value2: 'Learning organization',
    value3: 'Compete to win',
    aim: 'We are committed to addressing unmet medical needs.'
  },
  about: {
    our_story: 'Our Story',
    about_us: 'About Us',
    about_dizal: 'About Dizal',
    about_1:
      'Dizal is a biopharmaceutical company, dedicated to the discovery, development and commercialization of differentiated therapeutics for the treatment of oncology and hematological diseases. The company aims to develop first-in-class and groundbreaking new medicines, and further address unmet medical needs around the world. Deep-rooted in translational science and molecular design, Dizal has established an internationally competitive portfolio. Golidocitinib is approved in China. ZEGFROVY® is approved in both the U.S. and China, with worldwide development and commercialization rights licensed to AstraZeneca.',
    about_2: ''
  },
  strategy: {
    strategy_1: 'Aiming at the treatment of oncology and hematological diseases as well as other critical diseases.',
    strategy_2: 'Maintaining our competitive edges in the capabilities of translational science, medicinal chemistry and drug design.',
    strategy_3: 'Expanding global competitive portfolio mainly through internal drug discovery engine.'
  },
  development_history: [
    {
      year: '2017-10',
      text: 'Dizal Pharmaceutical Founded'
    },
    {
      year: '2017-12',
      text: 'First Clinical Trial Approved'
    },
    {
      year: '2019-08',
      text: 'First Clinical Study Completed'
    },
    {
      year: '2020-10',
      text: 'First Pivotal Study Initiated'
    },
    {
      year: '2020-12',
      text: 'Sunvozertinib Granted Breakthrough Therapy Designation by CDE'
    },
    {
      year: '2021-12',
      text: 'Listed on the SSE Board'
    },
    {
      year: '2022-01',
      text: 'Sunvozertinib Granted Breakthrough Therapy Designation by FDA'
    },
    {
      year: '2022-02',
      text: 'Golidocitinib Granted Fast Track Designation by FDA'
    },
    {
      year: '2023-08',
      text: 'Sunvozertinib NDA Approved by NMPA'
    },
    {
      year: '2024-06',
      text: 'Golidocitinib NDA Approved by NMPA'
    }
  ],
  campus_timeline: [
    {
      year: '2022.08.31',
      text: 'Online Application Launch'
    },
    {
      year: '2022.09-10',
      text: 'Campus Career Talk'
    },
    {
      year: '2022.09-10',
      text: 'Resume Screening'
    },
    {
      year: '2022.10-11',
      text: 'Interview'
    },
    {
      year: '2022.11-12',
      text: 'Send Offer'
    }
  ],
  contact_us: 'Contact Us',
  more: 'more',
  management: 'Management Team',
  board: 'Board of Directors',
  jobs: 'Opportunities',
  campus: 'Campus Hiring',
  copyright: 'DizalPharma. All Rights Reserved.',
  site_ref: 'Site Reference No：',
  //   Home: "Home",
  read_more: 'Read More',
  news_list: 'NEWS LIST',
  news_detail: 'NEWS DETAIL',
  return_to_news_list: 'Return to News List',
  oncology: 'Oncology',
  non_oncology: 'Non-oncology',
  expand_access_9008: 'Sunvozertinib (DZD9008)',
  expand_access_detail_9008:
    "At Dizal we aspire to discover and develop differentiated therapeutics for the treatment of oncology and hematological diseases. One of the Dizal's lead products, sunvozertinib, is an oral EGFR tyrosine kinase inhibitor (TKI). It is currently being investigated as a single agent in phase 2 and phase 3 clinical trials for the treatment of Non-Small Cell Lung Cancer (NSCLC) patients with EGFR Exon20ins mutation. We are enrolling and conducting clinical trials aiming at gaining regulatory approval to make sunvozertinib available to all eligible patients as quickly as possible. As such, we believe participation in our clinical trials is the most appropriate way to access sunvozertinib at this stage of development. Information about our clinical trials, including eligibility criteria and locations, is available at <a style='color:#ca113a;' target='_blank' href='https://clinicaltrials.gov/ct2/show/NCT03974022'>clinicaltrials.gov</a>.<br><br>Dizal understands the interest of patients in accessing drugs, such as sunvozertinib, outside of clinical trials and prior to regulatory approval for potentially life-threatening diseases. Because sunvozertinib is an investigational drug, and its efficacy and safety are still under evaluation, sunvozertinib can only be administered in accordance with local investigational drug requirement by an experienced physician. <br><br>Dizal now offers Individual Patient Access for its investigational drug sunvozertinib for the treatment of adult patients with Advanced Non-Small Cell Lung Cancer (NSCLC), with EGFR or HER2 mutation, at the sites participating in ongoing clinical trials of sunvozertinib. Individual patients at these sites may be able to access sunvozertinib if they are ineligible for the available standard of care and are recommended by the treating physician to the Individual Patient Access Program. <br><br>In order to meet FDA requirements, Dizal will provide a Letter of Authorization (LOA), referencing the content in Dizal’s US IND, to each treating physician to support their written requests (IND) for individual patient use. This same principle may be applied to countries with IND/CTA of sunvozertinib opened to fulfill the local regulatory requirements.",
  expand_access_4205: 'Golidocitinib (DZD4205, AZD4205)',
  expand_access_detail_4205:
    "At Dizal, we aspire to discover and develop differentiated therapeutics for the treatment of oncology and hematological diseases. One of Dizal's lead products, golidocitinib, is an oral, potent, highly selective Janus kinase 1 (JAK1) inhibitor. It is currently being investigated as a single agent in a phase 2 clinical trial for the treatment of patients with relapsed/refractory peripheral T-cell lymphoma (r/r PTCL). We are conducting clinical trials aiming at gaining regulatory approval to make golidocitinib available to all eligible patients as quickly as possible. As such, we believe participation in our clinical trials is the most appropriate way to access golidocitinib at this stage of development. Information about our clinical trials, including eligibility criteria and locations, is available at <a style='color:#ca113a;' target='_blank' href='https://clinicaltrials.gov/study/NCT04105010?term=AZD4205&checkSpell=false&rank=4'>clinicaltrials.gov</a>.<br><br>Dizal understands the interest of patients in accessing drugs, such as golidocitinib, outside of clinical trials and prior to regulatory approval for potentially life-threatening diseases. Because golidocitinib is an investigational drug, and its efficacy and safety are still under evaluation, golidocitinib can only be administered in accordance with local investigational drug requirements by an experienced physician. <br><br>Dizal now offers Individual Patient Access to the investigational drug golidocitinib for the treatment of adult patients with r/r PTCL at the sites participating in ongoing clinical trials of golidocitinib. Individual patients at these sites may be able to access golidocitinib if they are ineligible for the available standard of care and are recommended by the treating physician to the Individual Patient Access Program. <br><br>In order to meet the FDA's requirements, Dizal will provide a Letter of Authorization (LOA), referencing the content in Dizal's US IND, to each treating physician to support their written requests (IND) for individual patient use. The same principle may be applied to countries with IND/CTA of golidocitinib opened to fulfill the local regulatory requirements.",
  expand_access_8586: 'Birelentinib (DZD8586)',
  expand_access_detail_8586:
    "At Dizal, we aspire to discover and develop differentiated therapeutics for the treatment of oncology and hematological diseases. One of Dizal's lead products, birelentinib (DZD8586), is a novel oral LYN/BTK dual inhibitor with high potency and selectivity. It is currently being investigated as a single agent for the treatment of patients with relapsed/refractory Chronic lymphocytic leukemia or small lymphocytic lymphoma (CLL/SLL). We are conducting clinical trials aiming at gaining regulatory approval to make birelentinib available to all eligible patients as quickly as possible. As such, we believe participation in our clinical trials is the most appropriate way to access birelentinib at this stage of development. Information about our clinical trials, including eligibility criteria and locations, is available at <a style='color:#ca113a;' target='_blank' href='https://clinicaltrials.gov/search?term=DZD8586&rank=6'>clinicaltrials.gov</a>.<br><br>Dizal understands the interest of patients in accessing birelentinib outside of clinical trials and prior to regulatory approval for potentially life-threatening diseases. However, at this time we do not offer an Expanded Access Program for birelentinib.<br><br>Dizal recognizes the need for Expanded Access Programs and will re-evaluate the status of our policy based on data from ongoing and future clinical trials.",
  pipeline: {
    table: {
      project: 'Project',
      discovery: 'Discovery',
      IND_Enabling: 'IND Enabling',
      Ph1_does: 'Dose Escalation',
      Ph2_proof: 'Proof of Concept',
      Ph3_pivotal: 'Pivotal',
      NDA: 'NDA',
      approval: 'Approval',
      Ph1: 'Phase I',
      Ph2: 'Phase II',
      Ph3: 'Phase III',
      commercialRights: 'Commercial Rights',
      global: 'Global',
      dizal_AZ_split: 'Dizal/AZ split',
      PTCL: 'PTCL',
      HM: 'Hematological Malignancy',
      autoimmuneDiseases: 'Immunological Diseases',
      solidLiquidTumors: 'Solid & Liquid Tumors',
      solidTumors: 'Solid Tumors',
      Sunvozertinib: 'ZEGFROVY',
      Golidocitinib: 'Golidocitinib',
      DZD1516: 'DZD1516',
      DZD2269: 'DZD2269',
      DZD8586: 'Birelentinib',
      DZD6008: 'DZD6008',
      GW5282: 'GW5282',
      CKD: 'CKD',
      anti_virus: 'Anti-Viral',
      ps1: 'Note：1. Dizal grants AstraZeneca worldwide rights to develop and commercialise ZEGFROVY®',
      ps2: 'Note：2. The progress bar indicates the highest development phase of the project.',
      hematologicalMalignancy: 'Hematological Malignancy',
      sunvozertinibTip: ['Breakthrough Therapy Designation by NMPA and FDA', 'Priority Review by NMPA and FDA'],
      GolidocitinibTip: ['Fast Track Designation by FDA', 'Orphan Drug Designation by FDA', 'Priority Review by NMPA'],
      BirelentinibTip: ['Fast Track Designation by FDA'],
      recognition: 'Regulatory Designations'
    }
  },
  //  管理团队
  members: {
    //   张小林
    XiaolinZhang: {
      name: 'Xiaolin Zhang, Ph.D.',
      position: ['Chief Executive Officer'],
      edu: ['Adjunct Professor in Peking University', 'Ph.D. in Genetics, Oregon State University'],
      detail: [
        'Prior to founding Dizal Pharmaceutical in 2017, Dr. Zhang spent over twenty years at AstraZeneca, most recently as Global Vice President and Head of AEM iMED. Since joining Astra in 1998 as a senior scientist, he had various roles with increasing responsibilities: senior principal scientist, global project leader, director, executive director, global vice president (CEO-2 level). In 2006, Dr. Zhang established AstraZeneca Innovation Center China (“ICC”), where he oversaw all the global oncology translational science projects and pioneered China-based global biopharmaceutical innovation by bringing  AZD3759 and DZD2954, the internally-discovered innovative drug candidates into pre-clinical development and clinical trials respectively. He was also deeply involved in the R&D and market launch of AstraZeneca’s lung cancer blockbusters including Iressa and Tagrisso.',
        'Prior to joining AstraZeneca, he served at BioMolecular Engineering Center, Boston University and Harvard Cancer Center.'
      ]
    },
    // 杨振帆
    PamelaYang: {
      name: 'Pamela Yang, MD, Ph.D.',
      position: ['Chief Medical Officer'],
      edu: ['Doctor of Philosophy, The University of Hong Kong', 'Master of Clinical Medicine, West China School of Medicine, Sichuan University'],
      detail: [
        'Dr. Yang has more than ten years of clinic and clinical research experience. ',
        'Prior to joining Dizal Pharmaceutical, Dr. Yang spent nearly 10 years at AstraZeneca, most recently as Medical Science Director, AEM iMED. During her tenure at AstraZeneca, she led more than ten translational science projects incl. Iressa and Tagrisso, and drug R&D projects such as AZD3759 and AZD1390. She published more than 40 papers in peer-reviewed journals.',
        'Prior to joining AstraZeneca, she served as a liver surgeon in West China Hospital, SCU (former known as the First Affiliated Hospital of West China University of Medical Science) and The First Affiliated Hospital of Chongqing Medical University. She received a doctorate of philosophy from Faculty of Medicine of the University of Hong Kong in 2002 and appointed as Research Professor in 2004.'
      ]
    },
    HongbinLyu: {
      name: 'Hongbin Lyu',
      position: ['Chief Financial Officer'],
      edu: ['MBA, Central University of Finance and Economics, CFA'],
      detail: [
        'Mr. Lyu has 20-year experience in investment banking and related business.',
        'Prior to joining Dizal Pharmaceutical, Mr. Lyu served as Head of Healthcare Industry Department at Huatai United Securities and Head of Healthcare Industry of Department at CICC. The healthcare projects led by Mr. Lyu include A-share and H-share IPO of WuXi AppTec, A-share IPO of Mindray Bio-Medical Electronics, A-share STAR Board IPO of Sunshine Guojian Pharma, Merger and reorganization of Aier Eye Hospital, Backdoor listing of Aosaikang Pharma, IPO of 3S Bio in Hong Kong, Non-public offering of Aier Eye Hospital, etc.'
      ]
    },
    // Anita Wu
    AnitaWu: {
      name: 'Qingyi (Anita) Wu',
      position: ['Chief Commercial Officer'],
      edu: [''],
      detail: [
        'Ms. Wu has over 25 years of commercial experience in global pharmaceutical and biotech companies',
        'Before joining Dizal, Ms. Wu was the Chief Commercial Officer for the greater China business at BeiGene, with responsibilities for establishing the broad market business, integrated commercialization platforms, and NRDL listing. ',
        'Prior to that, Ms. Wu served as General Manager for Specialty Care Business Unit at the Sanofi China, where she played a leading role in shaping rare disease policies. Before that, she worked at AstraZeneca China as an executive director of diabetes and metabolism business. Ms. Wu started her biotech experience at Genzyme, and she played a major role in ONC Asia emerging market team at Pfizer.'
      ]
    },
    // 陈素勤
    SusanChen: {
      name: 'Susan Chen',
      position: ['Senior Vice President, Clinical Operation'],
      edu: ['Bachelor of Traditional Chinese Medicine, China Pharmaceutical University'],
      detail: [
        'Ms. Chen has over 20 years of global clinical operations experience. Prior to joining Dizal Pharmaceutical, Ms. Chen served as Head of China Clinical Operations Hub at AstraZeneca. During her tenure at AstraZeneca, Ms. Chen played a leading role in establishing China Clinical Operations Hub, which functions in parallel with other three international Clinical Operations Hubs to deliver AZ late-stage global portfolio. She also led a wide range of global Phase I-II-III clinical trials of novel therapies for the treatment of oncology, cardiovascular, gastroenterology and inflammation disease such as Tagrisso, AZD3759, CAZ-AVI and PDL-1, covering more than 30 countries in the world.',
        'Prior to joining AstraZeneca, she served as Head of Country & Site Management, China in Roche Pharma Development Center in Asia Pacific. During her tenure at Roche, she led the team to deliver more than thirty global/China registration projects such as Herceptin, Tarceva and Avastin. She also served at Eli Lily and Tianjin Tanabe Pharmaceutical Company.'
      ]
    },
    // 曾庆北
    QingbeiZeng: {
      name: 'Qingbei Zeng, Ph.D.',
      position: ['Senior Vice President, Chief Scientist'],
      edu: ['Ph.D. in Chemistry, The Ohio State University'],
      detail: [
        'Dr. Zeng has 20-year experiences in drug design and discovery. His research spanned disease areas of oncology, viral infection, immunology, and allergy. Dr. Zeng is an inventor or co-inventor of multiple drug candidates in clinical trials. Prior to joining Dizal Pharmaceutical, Dr. Zeng served as senior principal researcher at AstraZeneca Innovation Center China (“ICC”). During his tenure at AstraZeneca, he played a major role in the discovery of AZD3759, the first drug candidate discovered in China. Dr. Zeng served at Schering-Plough and Merck in the United States prior to joining AstraZeneca.'
      ]
    },
    // 徐汉忠
    HonchungTsui: {
      name: 'Honchung Tsui, Ph.D.',
      position: ['Senior Vice President, Medicinal Chemistry'],
      edu: ['Postdoctoral Fellow, Stanford University', 'Ph.D. in Chemistry, The Ohio State University'],
      detail: [
        'Dr. Tsui has more than ten years of experience in drug discovery and management. Prior to joining Dizal Pharmaceutical, Dr. Tsui served as principal scientist at AstraZeneca China.  Prior to joining AstraZeneca, Dr. Tsui had worked at Schering-Plough/Merck in the United States. During his tenure at Schering-Plough/Merck, he played a major part in the discovery of Rolapitant, the innovative therapy for the treatment of chemotherapy-induced nausea and vomiting (CINV), which has been launched into the US and European markets since 2015. Dr. Tsui has more than twenty invention patents and published more than twenty papers in the peer-reviewed journals.'
      ]
    },
    // 张世英博士
    SHIH_YING_CHANG: {
      name: 'SHIH-YING CHANG, Ph.D.',
      position: ['Vice President, Chemical Manufacturing Control'],
      edu: ['Ph.D. in Chemical Engineering, University of Maryland, College Park'],
      detail: [
        'Dr. Chang has over 10-year experiences in novel formulation development, technology transfer, and clinical supply. Prior to joining Dizal Pharmaceutical, he served as Executive Director of Pharmaceutical Sciences/Formulation Research and Development Department at Hutchison MediPharma Inc. Prior to joining Hutchison MediPharma, Dr. Chang had 12-year pharmaceutical experience at Bristol-Myers Squibb (BMS) in the United States, where he was involved in API crystallization and drying, formulation development, process scale-up and technology transfer.',
        'Over the course of his career, Dr. Chang has been involved in development of multiple small molecule compounds across from preclinical to commercialization stages. He has also participated in NDA filing preparation, including 4 filings with FDA and 1 filing with CFDA. He has developed multiple new formulations and technologies including lipid formulations, self-microemulsifying drug delivery systems (SMEDDS), spray-dried dispersion (SDD), co-precipitation (CPT), Moisture Activated Dry Grannulation (MADG), and active ingredient coating.'
      ]
    },
    // 张知为
    VioletZhang: {
      name: 'Violet Zhang',
      position: ['Vice President, Operation'],
      edu: ['Master, Organizational Human Resource Management, Hong Kong University', 'Bachelor of Arts, East China Normal University'],
      detail: ['Ms. Zhang has around 20 years management experience in healthcare and pharmaceutical industry. Prior to joining Dizal Pharmaceutical, Ms. Zhang served as associate director of HR department at AstraZeneca China.']
    }
  },
  //   董事会
  boards: {
    // 张小林博士
    XiaolinZhang: {
      name: 'Xiaolin Zhang, Ph.D.',
      position: ['Chief Executive Officer, Dizal Pharmaceutical'],
      detail: [
        'Dr. Zhang co-founded our company and has been our Chairman and Chief Executive Officer since 2017.',
        'Prior to that, Dr. Zhang spent over twenty years at AstraZeneca, most recently as Global Vice President and Head of AEM iMED. Since joining Astra in 1998 as a senior scientist, he had various roles with increasing responsibilities: senior principal scientist, global project leader, director, executive director, global vice president (CEO-2 level). In 2006, Dr. Zhang established AstraZeneca Innovation Center China (“ICC”), where he oversaw all the global oncology translational science projects and pioneered China-based global biopharmaceutical innovation by bringing AZD3759 and DZD2954, the internally-discovered innovative drug candidates into pre-clinical development and clinical trials respectively. He was also deeply involved in the R&D and market launch of AstraZeneca’s lung cancer blockbusters including Iressa and Tagrisso.',
        'Prior to joining AstraZeneca, he served at BioMolecular Engineering Center, Boston University and Harvard Cancer Center.'
      ]
    },
    // 吕大忠博士
    SimonLu: {
      name: 'Simon Lu, Ph.D.',
      position: ['Managing Director, SDIC FUND'],
      detail: [
        'Dr. Lu has been our Director since 2017.',
        "He joined SDIC Fund in August 2009 as Managing Director, who is now mainly responsible for the firm's healthcare industry investment. Before joining SDIC Fund, Dr. Lu held positions at CEL Partners, Newmargin Ventures, Scotiabank, CICC and Arthur Andersen. He has more than 20 years working experiences in private equity investment and business consulting.",
        'Dr. Lu graduated with Bachelor and Ph.D. of Economics degree from Nankai University in China, and he earned an MBA degree from McGill University in Canada.'
      ]
    },
    // 傅晓
    // Fuxiao: {
    //   name: 'Christine Fu',
    //   position: ['Managing Director, SDIC FUND'],
    //   detail: [
    //     'Ms. Fu has been our Director since 2017.',
    //     'She has over 25 years experiences in the finance and investment consulting service field. She joined the SDIC Fund in 2012. She previously served at WLR China Energy & Infrastructures Fund, Affinity Equity Partners, Goldman Sachs (Asia) and Arthur Anderson. ',
    //     'Ms. Fu obtained a bachelor’s degree from the Central University of Finance and Economics and a master’s degree from the London School of Economics and Political Science.'
    //   ]
    // },
    // Menelas Pangalos 博士
    // MenelasPangalos: {
    //   name: 'Menelas Pangalos, Ph.D.',
    //   position: ['Executive Vice-President, Research & Development BioPharmaceuticals, AstraZeneca'],
    //   detail: [
    //     'Dr. Pangalos has been our Director since 2017. ',
    //     'He was appointed as Executive Vice-President, BioPharmaceuticals R&D in January 2019 and is responsible for R&D from discovery through to late-stage development across CVRM, Respiratory and Immunology, Neuroscience and Infection. Prior to this, he served as Executive Vice-President of AstraZeneca’s IMED Biotech Unit and Global Business Development. Since joining AstraZeneca in 2010, he has led the transformation of our R&D. He previously held senior R&D roles at Pfizer, Wyeth and GSK. Dr. Pangalos is a Fellow of the Academy of Medical Sciences, the Royal Society of Biology and Clare Hall, University of Cambridge. He sits on the Medical Research Council, co-chairs the Life Sciences Council Expert Group on Innovation, Clinical Research and Data. He is on the Boards of The Francis Crick Institute, The Judge Business School and Dizal Pharma. Dr. Pangalos has been awarded honorary doctorates from Glasgow University and Imperial College London, and in 2019 was awarded with a knighthood from The Queen and the Prix Galien Medal, Greece. Dr. Pangalos also oversees the creation of AstraZeneca’s new Global R&D Centre in Cambridge.'
    //   ]
    // },
    /* Rodolphe Grépinet*/
    Rodolphe: {
      name: 'Rodolphe Grépinet',
      position: ['Vice President, Corporate Development, AstraZeneca'],
      detail: [
        'Mr. Grépinet has been our Director since 2017.',
        'As Head of Corporate Development and Senior Vice President, he oversees the evaluation and execution of global transformational opportunities for AstraZeneca across all therapy areas, reporting to the Chief Strategy Officer. During the past two decades, he has been involved in assessing, structuring and negotiating corporate Mergers & Acquisitions (M&A) and business development transactions with an aggregate value exceeding $300bn.',
        'Prior to joining AstraZeneca in 2014, he worked as an M&A investment banker for 17 years in Europe and the US where he advised life sciences clients globally. In his last role, he was a co-founding Partner of Torrey Partners, a healthcare M&A advisory firm after holding positions of increasing responsibility at Morgan Stanley, UBS and Deutsche Bank.',
        'He graduated from ESCP Business School with a Master in Management.'
      ]
    },
    CaoYibo: {
      name: 'Yibo Cao',
      position: ['Independent Director'],
      detail: [
        'Mr. Cao has been our Independent Director since August 2026.',
        'He is currently a Managing Director of Hongshan (formerly known as Sequoia Capital China). Previously, he served as a Managing Director at Vivo Capital LLC from August 2011 to July 2017.',
        'Mr. Cao holds a Master’s degree in Clinical Pharmacy from Peking University.'
      ]
    },
    MeixiaAn: {
      name: 'Meixia An',
      position: ['Independent Director'],
      detail: [
        'Ms. An has been our Independent Director since December 2024.',
        'She is currently a faculty member at the School of Economics and Management, Huangshan University. Previously, she has held positions at Shanghai Tongji Science & Technology Industry Co., Ltd., China State Institute of Pharmaceutical Industry, and Tianbang Foodstuffs Co., Ltd.',
        "Ms. An holds a Master's degree in Economics from Shanghai University of Finance and Economics and is a Certified Public Accountant (CPA) as well as a Senior Accountant."
      ]
    },
    TianYouWang: {
      name: 'Tianyou Wang',
      position: ['Independent Director'],
      detail: [
        'Ms. Wang has been our Independent Director since January 2026.',
        'She is licensed responsible officer of the Securities and Futures Commission of Hong Kong (SFC). She is currently Chief Executive Officer of Wisdom Cosmic Hong Kong Limited. ',
        'Previously, she has held positions at Standard Chartered Bank, BNP Paribas, Union Bancaire Privée (UBP), Harvest Global Investments Limited, Haitong International Securities Group Limited, Citigroup Global Markets Limited.'
      ]
    },
    LucyKang: {
      name: 'Xiaojing Kang',
      position: ['Employee Representative Director'],
      detail: [
        'Ms. Kang has been our Employee Representative Director since November 2025.',
        'She is currently serving as Finance VP of Dizal. She has over 20-year financial management experience and previously served as Financial Analyst Manager at AstraZeneca China Science Unit.',
        'Ms. Kang holds a Master’s degree in Business Administration from East China University of Science and Technology and has accountant qualification.'
      ]
    }
  },
  diseaseAreas: {
    lung: {
      key: 'lang',
      name: 'Lung Cancer',
      img: 'DA1@2X.jpg',
      intro: [
        'In China and even globally, the incidence and death rate of lung cancer rank first among all malignant tumors, and the disease has a very low five-year survival rate of only 15-20%. Non-small-cell lung cancer accounts for 80% of all lung cancers, and although a series of targeted drugs has been launched or is under development, due to the complexity and variety of disease mechanisms involved, a large number of patients still do not benefit from adequate treatment, an as-of-yet unresolved critical clinical issue.A mutation-specific kinase inhibitor researched and developed independently by Dizal Pharma has led to the successful screening of a candidate compound.',
        "Pre-clinical trials have shown that the candidate compound effectively inhibits the activation of kinase and its downstream signaling pathway in lung cancer tumor cells, thereby inhibiting tumor cell growth. Compared with currently approved similar targeted drugs, the new compound has equivalent to higher effectiveness in inhibiting identical targeted mutation types, and also inhibits mutation types previously not shown to be covered by other medicines in clinical research. It can be predicted that after entering clinical trials, the new drug will prove to combine therapeutic effectiveness, safety and wide mutation coverage, bringing hope to large numbers of non-small-cell lung cancer patients, and setting a new benchmark for the new generation of lung cancer targeted drugs. Meanwhile, translational medical results and pre-clinical data suggest that the inhibitor's indications may also be extended to other types of cancer, such as breast cancer, benefiting even more patients. This mutation-specific kinase inhibitor is an innovative drug originally developed in China which is expected to enter global Phase I clinical trial in 2019, a step effectively realizing the company’s ambition of driving medical innovation From China to Global, laden with incalculable academic significance and potential economic benefits as well as global influence."
      ]
    },
    kidney: {
      key: 'kidney',
      name: 'Chronic Kidney Disease',
      img: 'DA2@2X.jpg',
      intro: [
        'Proteinuria is a salient clinical feature of renal injury, and long-term persistent proteinuria can lead to lower renal function and even to end-stage renal disease. A 1.1-type small-molecule inhibitor aimed at the treatment of thyroiditis-related chronic proteinuria, discovered by Dizal Pharma and co-developed with the AstraZeneca International team, has enabled the identification of two candidate compounds currently at the stage of pre-clinical R&D. In vitro experiments have shown these candidate compounds effectively protect podocytes from damage. In a transgenic rat model of the human disease, the candidate compounds have been shown to effectively restore podocyte protrusions in the glomerular filtration barrier, delay the loss of podocytes, control proteinuria in animals in a dose-dependent manner, slow the impairment of renal function and significantly improve kidney tissue pathology. In-vivo pharmacological tests comparing the compounds with drugs currently used in standard clinical therapy have shown the former’s effectiveness in reducing proteinuria to be significantly higher.',
        'The compound is intended to be used in the treatment of chronic kidney disease with heavy proteinuria, in particular focal segmental glomerulonephritis resulting in primary resistance to hormone therapy, thereby helping solve this clinical problem. In addition, translational medicine data suggests that the compounds’ indications may also be extended to other fields including diabetic nephropathy and heart failure among others. This compound is far ahead of other similar drugs in the R&D process and is expected to enter global clinical trials in 2019 or 2020, to subsequently become the first specific targeted inhibitor active on podocytes to enter the market. Once it enters clinical practice, the compound is foreseen to become an irreplaceable new drug bringing new hope to patients and with considerable academic significance, business value and benefits to society.'
      ]
    },
    inflammatory: {
      key: 'inflammatory',
      name: 'Inflammatory Bowel Disease',
      img: 'DA3@2X.jpg',
      intro: [
        "IBD is a type of chronic non-specific intestinal inflammatory disease of unknown etiology which includes Crohn's Disease (CD) and Ulcerative Colitis (UC). It is the main cause of common digestive system ailments and chronic diarrhea. In China, the prevalence rates of UC and CD are 11.6/100,000 and 1.4/100,000, respectively. Current IBD treatment limitations include lack of definitive curative effect and numerous adverse reactions. Most patients with IBD are young adults affected by lifelong recurrent episodes of disease, a major disease burden to society in addition to patients' lives.",
        'A kinase inhibitor independently developed by Dizal Pharma has enabled the successful screening of a candidate compound. Pre-clinical studies have shown the compound to effectively inhibit the activation of signaling pathways of autoimmune diseases including inflammatory bowel disease and regulate multiple cytokines involved in the pathogenesis of IBD and other autoimmune diseases. Compared with similar drugs that have been approved or are under study, the drug shows superior target selectivity, higher bio-availability and longer half-life. Once it enters clinical practice, the new drug is expected to yield a combination of effective treatment and high safety, bringing a new treatment option to autoimmune disease patients. Based on existing pre-clinical and translational scientific data, the indications for the drug are expected to be expanded to other autoimmune diseases. The kinase inhibitor is an innovative drug originally developed in China and is expected to enter global phase I clinical research in 2019, realizing globally synchronized research and development.'
      ]
    },
    anti_virus: {
      key: 'anti_virus',
      name: 'Anti-Virus',
      img: 'DA4@2X.jpg',
      intro: [
        'Infectious diseases of the respiratory tract can be caused by a variety of microbial infections brought about by viruses, bacteria, mycoplasma, chlamydia and legionella among others, and are characterized by high seasonality, high incidence, and general susceptibility to infection among the population. Thanks to the discovery and use of antibiotics, the rate of bacterial lower respiratory tract infections has decreased year after year. However, due to factors such as global warming and air pollution, the rate of viral lower respiratory tract infections has been rising yearly and has become the leading cause of death among children under five years old globally. Among infants less than 6 months old, 45% of hospital admissions and deaths are caused by virus-induced acute lower respiratory tract infections. Among adults over 65 years old with immune deficiency or cardiopulmonary function insufficiency, viruses are also a common cause of serious lower respiratory infections. There currently exists no effective means of treatment for viral respiratory infections.',
        'To address this lack, Dizal Pharma has independently researched and developed a new anti-viral small-molecule compound. In cell-level experiments, this compound has been shown to effectively inhibit the replication and proliferation of viruses, and to have a wide-ranging inhibition effect on clinical strains. Its remarkable proliferation inhibition effect on strains which are drug-resistant to similar drugs indicates that the compound has a unique action point. Preliminary experimental results have also shown that small-molecule compounds of this type have the potential to prevent and treat viral infections. In animal tests, the compound has been shown to markedly reduce virus titer and alleviate airway tissue necrosis and lung inflammation caused by the viral infection. This new compound originally researched in China is now at the pre-clinical development stage.'
      ]
    }
  },
  publications: {
    key: 'Publications',
    core: 'Science is the foundation for all Dizal does.',
    intro: 'With deep-rooted science-led culture, our pioneering scientists regularly publish their research in peer-reviewed journals and deliver presentations at world-leading scientific conferences.',
    tab: {
      Sunvozertinib: 'Sunvozertinib',
      Golidocitinib: 'Golidocitinib',
      DZD2269: 'DZD2269',
      DZD8586: 'Birelentinib',
      DZD6008: 'DZD6008',
      DZD1516: 'DZD1516'
    },
    Sunvozertinib: [
      {
        intro: 'Mini Oral Presentation of Tumor Tissue and Plasma EGFR Exon 20 Insertion Mutation Status in NSCLC Patients Treated with Sunvozertinib at 2023 WCLC',
        dec: [
          {
            title: 'Tumor Tissue and Plasma EGFR Exon 20 Insertion Mutation Status in NSCLC Patients Treated with Sunvozertinib',
            item: [
              {
                date: '9/11/2023',
                detail: {
                  Presenter: 'Mengzhao Wang',
                  Meeting: '2023 World Conference on Lung Cancer',
                  Session: 'MA14Genetic Biomarkers for NSCLC'
                },
                link: 'https://cattendee.abstractsonline.com/meeting/10925/Session/113'
              }
            ]
          }
        ]
      },
      {
        intro: 'Sunvozertinib for the treatment of NSCLC with EGFR Exon20 insertion mutations: The first pivotal study results at 2023ASCO',
        dec: [
          {
            title: 'Sunvozertinib for the treatment of NSCLC with EGFR Exon20 insertion mutations: The first pivotal study results',
            item: [
              {
                date: '6/6/2023',
                detail: {
                  Presenter: 'Mengzhao Wang',
                  Meeting: '2023 American Society of Clinical Oncology',
                  Session: 'Lung Cancer – Non-Small Cell Metastatic'
                },
                link: 'https://meetings.asco.org/abstracts-presentations/220375'
              }
            ]
          }
        ]
      },
      {
        intro: 'Efficacy and safety of sunvozertinib in treatment naïve NSCLC patients with EGFR exon20 insertion mutations at 2023ASCO',
        dec: [
          {
            title: 'Efficacy and safety of sunvozertinib in treatment naïve NSCLC patients with EGFR exon20 insertion mutations ',
            item: [
              {
                date: '6/4/2023',
                detail: {
                  Presenter: 'Yan Xu',
                  Meeting: '2023 American Society of Clinical Oncology',
                  Session: 'Lung Cancer – Non-Small Cell Metastatic'
                },
                link: 'https://meetings.asco.org/abstracts-presentations/218846'
              }
            ]
          }
        ]
      },
      {
        intro: 'Anti-tumor activity of sunvozertinib in NSCLC with EGFR sensitizing mutations after failure of EGFR TKI treatment 2023ASCO',
        dec: [
          {
            title: 'Anti-tumor activity of sunvozertinib in NSCLC with EGFR sensitizing mutations after failure of EGFR TKI treatment',
            item: [
              {
                date: '6/4/2023',
                detail: {
                  Presenter: 'James Chih-Hsin Yang',
                  Meeting: '2023 American Society of Clinical Oncology',
                  Session: 'Lung Cancer – Non-Small Cell Metastatic'
                },
                link: 'https://meetings.asco.org/abstracts-presentations/218922'
              }
            ]
          }
        ]
      },
      {
        intro: 'Oral Presentation on the Researching Findings in the Correlation between the EGFR Exon20ins Mutations Changes in ctDNA and Antitumor Efficacy in Patients with the Therapy of Sunvozertinib at 2022 CSCO',
        dec: [
          {
            title: 'Researching Findings in the Correlation between the EGFR Exon20ins Mutations Changes in ctDNA and Antitumor Efficacy in Patients with the Therapy of Sunvozertinib',
            item: [
              {
                date: '11/9/2022',
                detail: {
                  Presenter: 'Yan Xu',
                  Meeting: '2022 Chinese Society of Clinical Oncology',
                  Session: 'Panel Discussion on NSCLS'
                },
                link: 'http://www.dizalpharma.com/news/detail?id=28'
              }
            ]
          }
        ]
      },
      {
        intro: 'Oral Presentation on Pivotal Study of Sunvozertinib in Platinum-Treated NSCLC Patients with EGFR Exon20ins Mutations at 2022 CSCO',
        dec: [
          {
            title: 'Pivotal Study of Sunvozertinib in Platinum-Treated NSCLC Patients with EGFR Exon20ins Mutations ',
            item: [
              {
                date: '11/5/2022',
                detail: {
                  Presenter: 'Mengzhao Wang',
                  Meeting: '2022 Chinese Society of Clinical Oncology',
                  Session: 'Clinical Data of Innovative Drugs 1'
                },
                link: 'http://www.dizalpharma.com/news/detail?id=28'
              }
            ]
          }
        ]
      },
      {
        intro: 'Oral Presentation on Sunvozertinib in NSCLC Patients with EGFR Exon20 Insertion Mutations at 2022 NACLC',
        dec: [
          {
            title: 'Sunvozertinib in NSCLC Patients with EGFR Exon20 Insertion Mutations',
            item: [
              {
                date: '9/24/2022',
                intro: 'Abstract OA01.07',
                detail: {
                  Presenter: 'Lyudmila Bazhenova',
                  Meeting: '2022 North America Conference on Lung Cancer',
                  Session: 'Oral Abstract Session 01 (OA01)'
                },
                link: 'http://www.dizalpharma.com/news/detail?id=24'
              }
            ]
          }
        ]
      },
      {
        intro: 'Report on Preliminary Analysis of the First Pivotal Study Results of Sunvozertinib for NSCLC Patients with EGFR Exon20 Insertion Mutations at 2022 ESMO',
        dec: [
          {
            title: 'Sunvozertinib for NSCLC patients with EGFR Exon20 Insertion Mutations: Preliminary Analysis of WU-KONG6, the First Pivotal Study',
            item: [
              {
                date: '9/10/2022',
                intro: 'Report Code: 987P',
                detail: {
                  'Lead Author': 'Mengzhao Wang',
                  Meeting: '2022 European Society for Medical Oncology',
                  Session: 'Poster session 14'
                },
                link: 'https://oncologypro.esmo.org/meeting-resources/esmo-congress/sunvozertinib-for-nsclc-patients-with-egfr-exon-20-insertion-mutations-preliminary-analysis-of-wu-kong6-the-first-pivotal-study'
              }
            ]
          }
        ]
      },
      {
        intro: 'Report on Sunvozertinib for NSCLC Patients with EGFR Exon20 Insertion Mutations at 2022 WCLC',
        dec: [
          {
            title: 'Sunvozertinib for NSCLC Patients with EGFR Exon20 Insertion Mutations',
            item: [
              {
                date: '7/8/2022',
                intro: 'Poster Code EP08.02-029',
                detail: {
                  Presenter: 'James Chih-Hsin Yang',
                  Meeting: '2022 World Conference on Lung Center',
                  Session: 'EP08.02 – Metastatic Non-small Cell Lung Cancer - Molecular Targeted Treatments'
                },
                link: 'https://wclc2022.iaslc.org/wp-content/uploads/2022/07/WCLC2022-Abstract-Book.pdf'
              }
            ]
          }
        ]
      },
      {
        intro: 'Poster Discussion on Anti-tumor Activity of Sunvozertinib in NSCLC Patients with EGFR Exon20 Insertion Mutations After Platinum and Anti-PD(L)1 Treatment Failures at 2022 ASCO',
        dec: [
          {
            title: 'Antitumor Activity of Sunvozertinib in NSCLC Patients with EGFR Exon20 Insertion Mutations After Platinum and Anti-PD(L)1 Treatment Failures',
            item: [
              {
                date: '6/6/2022',
                intro: 'Abstract #9015',
                detail: {
                  'Lead Author': 'Pasi A. Janne',
                  Meeting: '2022 Annual Meeting of the American Society of Cancer Oncology',
                  'Poster Discussion Session': 'Lung Cancer—Non-Small Cell Metastatic | Hall D1'
                },
                link: 'https://meetings.asco.org/abstracts-presentations/209838'
              }
            ]
          }
        ]
      },
      {
        intro: 'Publication of Sunvozertinib, a Selective EGFR Inhibitor for Previously Treated Non–Small Cell Lung Cancer with EGFR Exon20 Insertion Mutations  in Cancer Discovery',
        dec: [
          {
            title: 'Sunvozertinib, a Selective EGFR Inhibitor for Previously Treated Non–Small Cell Lung Cancer with EGFR Exon20 Insertion Mutations',
            item: [
              {
                detail: {
                  'Lead Author': 'Mengzhao Wang，James Chih-Hsin Yang',
                  IF: '39.397'
                },
                link: 'https://aacrjournals.org/cancerdiscovery/article/12/7/1676/705231/Sunvozertinib-a-Selective-EGFR-Inhibitor-for'
              }
            ]
          }
        ]
      },
      {
        intro: 'Report on Phase 1 Studies of DZD9008, an Oral, Selective EGFR/HER2 Inhibitor in Advanced NSCLC with EGFR Exon20 Insertion Mutation Has Been Selected for Oral Presentation at the 2021 World Conference on Lung Cancer',
        dec: [
          {
            title: 'Phase 1 studies of DZD9008, an oral, selective EGFR/HER2 inhibitor in advanced NSCLC with EGFR Exon20 insertion mutation ',
            item: [
              {
                date: '9/12/2021',
                intro: 'Abstract: #402',
                detail: {
                  Presenter: 'Pasi A. Janne',
                  Meeting: '2021 World Conference on Lung Cancer',
                  Session: 'OA15 - Upcoming Molecular Targeted Agents for EGFR exon 20 Insertion and MET Skipping Mutation'
                },
                link: 'https://library.iaslc.org/conference-program?product_id=24&author=&category=&date=&session_type=&session=&presentation=&keyword=DZD9008&cme=undefined&'
              }
            ]
          }
        ]
      },
      {
        intro: 'Report on Phase I Clinical Studies of DZD9008 in NSCLC with EGFR Exon20 Insertion Mutations Has Been Selected for Oral Presentation at the 2021 American Society of Clinical Oncology (ASCO) Annual Meeting',
        dec: [
          {
            title: 'Preliminary safety and efficacy results from phase I studies of DZD9008 in NSCLC patients with EGFR Exon20 insertion mutations',
            item: [
              {
                date: '6/4/2021',
                intro: 'Abstract #9008：Preliminary safety and efficacy results from phase I studies of DZD9008 in NSCLC patients with EGFR Exon20 insertion mutations',
                detail: {
                  Author:
                    'James Chih-Hsin Yang, Mengzhao Wang, Paul Mitchell, Jian Fang, Weiqi Nian, Chao-Hua Chiu, Jianying Zhou, Yanqiu Zhao, Wu-Chou Su, D. R. Camidge, Tsung-Ying Yang, Viola W. Zhu, Michael Millward, Yun Fan, Wen Tsung Huang, Ying Cheng, Liyan Jiang, Li Zheng, Xiuhui Ye, Pasi A. Janne',
                  Meeting: 'the 2021 American Society of Clinical Oncology (ASCO) ',
                  Session: 'Lung Cancer—Non-Small Cell Metastatic'
                },
                link: 'https://meetinglibrary.asco.org/record/197248/abstract'
              }
            ]
          }
        ]
      },
      {
        intro: 'DZD9008, a potential EGFR TKI for the treatment of NSCLC patients with EGFR or HER2 Exon20ins and other activating mutations.',
        dec: [
          {
            title: 'DZD9008, a potential EGFR TKI for the treatment of NSCLC patients with EGFR or HER2 Exon20ins and other activating mutations.',
            item: [
              {
                date: 'March 29-April 3, 2019',
                intro: 'Abstract 3081: DZD9008, an oral, wild type selective EGFR inhibitor for the treatment of non-small-cell lung cancer with Exon20 insertion and other activating mutations',
                detail: {
                  Author: 'Yan Xu, Lin Zhang, Lifang Zhu, Yingchun Wang, Mei Wang, Zhenfan Yang.',
                  Meeting: 'The American Association for Cancer Research Annual Meeting 2019'
                },
                link: 'http://cancerres.aacrjournals.org/content/79/13_Supplement/3081'
              }
            ]
          }
        ]
      }
    ],
    Golidocitinib: [
      {
        intro: 'Clinical Results of Golidocitinib Published in Annals of Oncology',
        dec: [
          {
            title: 'Phase 1 Dose Escalation and Expansion Study of Golidocitinib, a Highly Selective JAK1 Inhibitor, in Relapsed or Refractory Peripheral T Cell Lymphomas',
            item: [
              {
                detail: {
                  'Lead Author': 'Yuqin Song'
                },
                link: 'https://www.annalsofoncology.org/article/S0923-7534(23)00828-1/fulltext#%20'
              }
            ]
          }
        ]
      },
      {
        intro: 'Golidocitinib in Treating Refractory or Relapsed Peripheral T- Cell Lymphoma: Primary Analysis of the Multinational Pivotal Study Results (JACKPOT8) at 17th ICML',
        dec: [
          {
            title: 'Golidocitinib in Treating Refractory or Relapsed Peripheral T- Cell Lymphoma: Primary Analysis of the Multinational Pivotal Study Results (JACKPOT8) ',
            item: [
              {
                date: '6/15/23023',
                detail: {
                  Presenter: 'Won-Seog Kim',
                  Meeting: '17th International Conference on Malignant Lymphoma',
                  Session: 'Peripheral T-Cell Lymphoma'
                },
                link: 'https://onlinelibrary.wiley.com/doi/10.1002/hon.3163_43'
              }
            ]
          }
        ]
      },
      {
        intro: 'Golidocitinib in treating refractory or relapsed peripheral T-cell lymphoma: Primary analysis of the multinational pivotal study results (JACKPOT8) at 2023ASCO',
        dec: [
          {
            title: 'Golidocitinib in treating refractory or relapsed peripheral T-cell lymphoma: Primary analysis of the multinational pivotal study results (JACKPOT8)',
            item: [
              {
                date: '6/6/2023',
                detail: {
                  Presenter: 'Qingqing Cai',
                  Meeting: '2023 American Society of Clinical Oncology',
                  Session: 'Hematologic Malignancies – Lymphoma and Chronic Lymphocytic Leukemia'
                },
                link: 'https://meetings.asco.org/abstracts-presentations/218269'
              }
            ]
          }
        ]
      },
      {
        intro: 'Report on Pivotal Study of Golidocitinib in Relapsed or Refractory Peripheral T-cell Lymphoma (r/r PTCL) at 2022 ASH',
        dec: [
          {
            title: 'Preliminary Biomarker Data from a Phase 1/2 Study of Golidocitinib Demonstrates Targeting JAK/STAT Pathway to Treat Peripheral T-Cell Lymphoma',
            item: [
              {
                date: '11/15/2022',
                detail: {
                  'Lead Author': 'Yuqin Song',
                  Meeting: '2022 American Society of Hematology'
                },
                link: 'https://ashpublications.org/blood/article/140/Supplement%201/6545/492123/Preliminary-Biomarker-Data-from-a-Phase-1-2-Study'
              }
            ]
          }
        ]
      },
      {
        intro: 'Report on the Phase I/II Study of Golidocitinib in Relapsed or Refractory Peripheral T-cell Lymphoma (r/r PTCL) at 2022 CSCO',
        dec: [
          {
            title: 'Phase I/II Clinical Study of Golicitinib, a Highly Selective JAK1 Inhibitor, in the Treatment of Relapsed or Refractory Peripheral T-cell Lymphoma',
            item: [
              {
                date: '11/5/2022-11/12/2022',
                intro: 'Poster Code:13782',
                detail: {
                  Author: 'Yuqin Song',
                  Meeting: '2022 Chinese Society of Clinical Oncology'
                },
                link: 'http://csco.kydev.net/poster/detail/79'
              }
            ]
          }
        ]
      },
      {
        intro: 'Oral Presentation of the Phase I/II Study of Golidocitinib, A Selective JAK1 Inhibitor, in Relapsed/Refractory Peripheral T-Cell Lymphoma at 2022 EHA',
        dec: [
          {
            title: 'A PhaseI/II Study of Golidocitinib, A Selective JAK1 Inhibitor, in Refractory / Relapsed Peripheral T Cell Lymphoma',
            item: [
              {
                date: '6/12/2022',
                intro: 'Abstract: S218',
                detail: {
                  Presenter: 'Won-Seog Kim',
                  Meeting: '2022 European Hematology Association',
                  Session: 'Aggressive Lymphoma - Novel agents'
                },
                link: 'https://library.ehaweb.org/eha/2022/eha2022-congress/357082/won-seog.kim.a.phase.i.ii.study.of.golidocitinib.a.selective.jak1.inhibitor.in.html?f=menu%3D6%2Abrowseby%3D8%2Asortby%3D2%2Amedia%3D3%2Ace_id%3D2233%2Aot_id%3D26858%2Amarker%3D1751%2Afeatured%3D17676'
              }
            ]
          }
        ]
      },
      {
        intro: 'Report on the Phase I/II Study of Golidocitinib, A Selective JAK1 Inhibitor, in Rrefractory or Relapsed Peripheral T-cell Lymphoma at 2022 ASCO',
        dec: [
          {
            title: 'A Phase I/II Study of Golidocitinib, A Selective JAK1 Inhibitor, in Rrefractory or Relapsed Peripheral T-cell Lymphoma',
            item: [
              {
                date: '6/4/2022',
                intro: 'Abstract #7563',
                detail: {
                  'Lead Author': 'Won Seog Kim',
                  Meeting: '2022 Annual Meeting of the American Society of Cancer Oncology',
                  'Poster Session': 'Hematologic Malignancies – Lymphoma and Chronic Lymphocytic Leukemia | Hall A'
                },
                link: 'https://meetings.asco.org/abstracts-presentations/210230'
              }
            ]
          }
        ]
      },
      {
        intro: 'Report on Phase I/II Clinical Study of DZD4205 in Relapsed/Refractory Peripheral T-Cell Lymphoma Has Been Selected for Oral Presentation at the 2021 International Conference on Malignant Lymphoma Lugano Annual Meeting',
        dec: [
          {
            title: 'Early safety and efficacy data from a phase I/II trial of DZD4205, a selective JAK1 inhibitor in relapsed/refractory peripheral T-Cell lymphoma ',
            item: [
              {
                date: '6/22/2021',
                intro: 'Abstract #: 57 Early safety and efficacy data from a phase I/II trial of DZD4205, a selective JAK1 inhibitor, in relapsed/refractory peripheral T-Cell lymphoma',
                detail: {
                  Presenter: 'Prof. Won-Seog Kim, Seoul (South Korea) ',
                  'Session 8': 'PERIPHERAL T/NK LYMPHOMAS'
                },
                link: 'http://www.dizalpharma.com/pdf/Abstract for Oral Presentation of DZD4205 at the 2021 ICML.pdf'
              }
            ]
          }
        ]
      },
      {
        intro: 'DZD4205, a selective JAK1 inhibitor for treatment of refractory or relapsed Peripheral T-Cell Lymphoma (PTCL) ',
        dec: [
          {
            title: 'Abstract has been selected as presentation in 2020 ASH Annual Meeting',
            item: [
              {
                intro: 'A Phase I/II Study (JACKPOT8) of DZD4205, a Selective JAK1 Inhibitor, in Refractory or Relapsed Peripheral T- Cell Lymphoma',
                detail: {
                  Author: 'Won-Seog Kim, Dok-Hyun Yoon, MD, PhD, Hyeon-Seok Eom, Youngil Koh, MD, PhD, Jae-Yong Kwak, Won-Sik Lee, Jong-Seok Lee, Ho-Jin Shin, Yuqin Song, MD, PhD, Haiyan Yang, MD, PhD, Mei Wang, Jingrun Li, MD, PhD, Xubin Huang, Xueyuan Deng, Kan Chen, Zhenfan Yang and Jun Zhu',
                  Meeting: '62nd ASH Annual Meeting and Exposition '
                },
                link: 'https://ash.confex.com/ash/2020/webprogram/Paper134650.html'
              }
            ]
          }
        ]
      },
      {
        intro: 'DZD4205(AZD4205), a potent, GI tract-enriched, JAK1-selective inhibitor for treatment of inflammatory bowel disease (IBD)',
        dec: [
          {
            title: 'Abstract has been elected as oral presentation in 2019 ECCO Annual Meeting ',
            item: [
              {
                intro: 'Abstract DOP017 – DZD4205(AZD4205), a potent, GI tract-enriched, JAK1-selective inhibitor for treatment of inflammatory bowel disease (IBD)',
                detail: {
                  Author: 'M Wang, T John, L Zhang, L Zhu, Y Xu, K Chen, S Han, J Li, F Wang, C Deceneux, A Behren, Z Yang',
                  Meeting: 'European Crohn’s and Colitis Organization 2019 '
                },
                link: 'https://www.ecco-ibd.eu/publications/congress-abstract-s/abstracts-2019/item/dop17-azd4205-a-potent-gi-tract-enriched-jak1-selective-inhibitor-for-treatment-of-inflammatory-bowel-disease-ibd.html'
              }
            ]
          }
        ]
      }
    ],
    DZD8586: [
      {
        intro: 'Treatment of B-cell Malignancies with DZD8586 Through Overcoming Both BTK-dependent and BTK-independent Resistance at 17th ICML',
        dec: [
          {
            title: 'Treatment of B-cell Malignancies with DZD8586 Through Overcoming Both BTK-dependent and BTK-independent Resistance ',
            item: [
              {
                date: '6/14/2023-6/16/2023',
                detail: {
                  Presenter: 'Keshu Zhou',
                  Meeting: '17th International Conference on Malignant Lymphoma'
                },
                link: 'https://onlinelibrary.wiley.com/doi/10.1002/hon.3165_655'
              }
            ]
          }
        ]
      }
    ],
    DZD2269: [
      {
        intro: 'Publication of DZD2269 in Journal of Experimental & Clinical Cancer Research',
        dec: [
          {
            title: 'Overcoming High Level Adenosine-mediated Immunosuppression by DZD2269, a Potent and Selective A2aR antagonist',
            item: [
              {
                detail: {
                  'Lead Author': 'Yu Bai, Xiaolin Zhang',
                  IF: '12.658'
                },
                link: 'https://jeccr.biomedcentral.com/articles/10.1186/s13046-022-02511-1?utm_source=xmol&utm_medium=affiliate&utm_content=meta&utm_campaign=DDCN_1_GL01_metadata'
              }
            ]
          }
        ]
      },
      {
        intro: 'Online Publication of Clinical Pharmacokinetic / Pharmacodynamic Relationship of DZD2269 at 2022 ASCO',
        dec: [
          {
            title: 'Clinical Pharmacokinetic / Pharmacodynamic Relationship of DZD2269, a Potent and Selective A2aR Antagonist Designed to Overcome High Levels of Adenosine Induced Immunosuppression',
            item: [
              {
                date: 'Online Publication',
                intro: 'Abstract #e15106',
                detail: {
                  'Lead Author': 'Ziyi Liu',
                  Meeting: '2022 Annual Meeting of the American Society of Cancer Oncology'
                },
                link: 'https://meetings.asco.org/abstracts-presentations/211837'
              }
            ]
          }
        ]
      }
    ],
    DZD1516: [
      {
        intro: 'Pre-clinical and Early Clinical Results of DZD1516 in Breast Cancer Research',
        dec: [
          {
            title: 'Preclinical and Clinical Activity of DZD1516, a Full Blood–brain Barrier-penetrant, Highly Selective HER2 Inhibitor',
            item: [
              {
                detail: {
                  'Lead Author': 'Jian Zhang'
                },
                link: 'https://breast-cancer-research.biomedcentral.com/articles/10.1186/s13058-023-01679-4'
              }
            ]
          }
        ]
      },
      {
        intro: 'Report on the Updated Data from the Phase 1 Trial of DZD1516, a BBB-penetrant Selective HER2 Inhibitor, in Patients with HER2 Positive Metastatic Breast Cancer at 2022 SABCS',
        dec: [
          {
            title: 'Updated Data from the Phase I trial of DZD1516, a BBB-penetrant Selective HER2 Inhibitor, in Patients with HER2 Positive Metastatic Breast Cancer',
            item: [
              {
                date: '12/9/2022',
                intro: 'Abstract #P4-01-23',
                detail: {
                  Meeting: '2022 San Antonio Breast Cancer Symposium',
                  'Lead Author': 'Jian Zhang'
                },
                link: 'http://www.dizalpharma.com/news/detail?id=34'
              }
            ]
          }
        ]
      },
      {
        intro: 'Oral Presentation on the Phase I Clinical Study of DZD1516, a BBB-penetrant Selective HER2 Inhibitor for the Treatment of HER2-positive Metastatic Breast Cancer at 2022 CSCO',
        dec: [
          {
            title: 'Phase I Clinical Study of DZD1516, a BBB-penetrant Selective HER2 Inhibitor for the Treatment of HER2-positive Metastatic Breast Cancer',
            item: [
              {
                date: '11/5/2022',
                detail: {
                  Presenter: 'Jian Zhang',
                  Meeting: '2022 Chinese Society of Clinical Oncology',
                  Session: 'Clinical Data of Innovative Drugs 1'
                },
                link: 'http://www.dizalpharma.com/news/detail?id=28'
              }
            ]
          }
        ]
      },
      {
        intro: 'Report on the Clinical Safety and Pharmacokinetics (PK) Data of DZD1516, a BBB-penetrant Selective HER2 Inhibitor for the Treatment of HER2 Positive Metastatic Breast Caner at 2022 ESMO',
        dec: [
          {
            title: 'Clinical Safety and Pharmacokinetics (PK) Data of DZD1516, a BBB-Penetrant Selective HER2 Inhibitor for the Treatment of HER2-positive Metastatic Breast Cancer',
            item: [
              {
                date: '9/10/2022',
                intro: 'Report Code: 238P',
                detail: {
                  'Lead Author': 'Jian Zhang',
                  Meeting: '2022 European Society for Medical Oncology',
                  Session: 'Poster session 02'
                },
                link: 'https://oncologypro.esmo.org/meeting-resources/esmo-congress/clinical-safety-and-pharmacokinetics-pk-data-of-dzd1516-an-bbb-penetrant-selective-her2-inhibitor-for-the-treatment-of-her2-positive-metastatic'
              }
            ]
          }
        ]
      },
      {
        intro: 'Report on the Early Clinical Safety and Parmacokinetics Data of DZD1516, a BBB-Penetrant Selective HER2 Inhibitor for the Treatment of HER2-positive Metastatic Breast Cancer at 2022 ASCO',
        dec: [
          {
            title: 'Early Clinical Safety and Parmacokinetics Data of DZD1516, a BBB-Penetrant Selective HER2 Inhibitor for the Treatment of HER2-positive Metastatic Breast Cancer',
            item: [
              {
                date: '6/6/2022',
                intro: 'Abstract #1038',
                detail: {
                  'Lead Author': 'Xichun Hu',
                  Meeting: '2022 Annual Meeting of the American Society of Cancer Oncology',
                  'Poster Session': 'Breast Cancer—Metastatic | Hall A'
                },
                link: 'https://meetings.asco.org/abstracts-presentations/210411'
              }
            ]
          }
        ]
      },
      {
        name: 'DZD1516',
        intro: 'Preclinical and Early Clinical Safety and Pharmacokinetics Data of DZD1516 in HER2 Positive Metastatic Breast Cancer Has Been Selected for Presentation at the 2021 San Antonio Breast Cancer Symposium.',
        dec: [
          {
            title: 'Preclinical and Early Clinical Safety and Pharmacokinetics Data of DZD1516, an BBB-penetrant Selective HER2 Inhibitor for the Treatment of HER2 Positive Metastatic Breast Cancer ',
            item: [
              {
                date: '12/8/2021, 5:00 PM – 6:30 PM CT',
                intro: 'Poster Session 2: P2-13-43',
                detail: {
                  Meeting: '2021 San Antonio Breast Cancer Symposium',
                  Session: 'Treatment - Therapeutic Strategies: HER2-Targeted Therapy',
                  Author: 'Jian Zhang, Nicholas McAndrew, Xichun Hu, etc.'
                },
                link: 'https://www.sabcs.org/Program/Poster-Sessions/Poster-Session-2'
              }
            ]
          }
        ]
      }
    ]
  },

  lung: 'LUNG CANCER',
  chronic: 'CHRONIC',
  kidney: 'KIDNEY DISEASE',
  inflammatory: 'INFLAMMATORY',
  bowel: 'BOWEL DISEASE',
  anti_virus: 'ANTI-VIRUS',
  anti_virus_project: 'Anti-Virus Project',
  apply: 'Apply',
  company_name: 'Dizal Pharma',
  tel: 'Tel',
  fax: 'Fax',
  email: 'Email',

  return_to_jobs: 'Return to Job List',
  back_to_news: 'Back to News List',

  we: 'WE',
  healthiest_award: 'AON HEALTHIEST EMPLOYER',
  outstanding_award: 'Outstanding Employer in Great China',
  healthiest_award_intro: 'Dizal Pharma – 2020 Aon Healthiest Employer Award- Emotional Healthiest Employer Award .',
  award1_desc: "Dizal won the 'Healthiest Employer Award' of Asia Best Workplace (Mainland China) 2021",
  award2_desc: 'Dizal won 2020 Aon Healthiest Employer Award - Emotional Healthiest Employer Award',
  award3_desc: "Dizal won the 'Best Wellness Employee Award' of ASIA BEST WORKPLACE ( Mainland China ) 2019.",
  award4_desc: "Dizal won the 'HRoot Awards 2022' of Outstanding Employer in Great China",
  asia_best: 'ASIA BEST WORKPLACE',
  asia_best_intro: "Dizal Pharmaceutical won the 'Best Wellness Employee Award' of ASIA BEST WORKPLACE ( Mainland China ) 2019.",
  health_center: 'Health Center',
  sports_team: 'Sports Teams',
  eap: 'EAP',
  health_well: 'Health Wellbeing Activities',

  great_place: 'Workplace',
  location_facilities: 'LOCATION AND FACILITIES',
  flexible: {
    name: 'FLEXIBLE WORKING ARRANGEMENT',
    detail: 'Dizal Pharma offers Flexible Work Programs for employees'
  },
  activity: {
    name: 'EMPLOYEE ENGAGEMENT ACTIVITIES',
    detail: 'Dizal Pharma sponsors a host of Employee Engagement activities such as Recognition Programs, Team-building Activities, and Family Day.'
  },
  follow_us: 'Follow Us By',
  latest_news: 'Latest News',
  job: {
    intro: ['We are looking for candidates who share our core values.', 'At Dizal, we offer various career opportunities with a competitive salary and benefits package. ', 'If you are interested in the open positions, please send C.V. to'],
    detail_btn: 'JOB DETAILS',
    list_name: 'Job List'
  },
  location: {
    name: 'Location',
    more: 'Find more',
    detail1: 'Dizal China is located in Zhangjiang Hi-Tech Park, Shanghai, where our R&D, Commercial and operation are located. We also have branch offices in Beijing, Wuxi, and Chengdu.',
    detail2: 'Our locations enable us to partner with academic, research and healthcare neighbors to explore life-changing therapeutics. Our state-of-the-art facility is well equipped and tailor-made for R&D into the entire lifecycle of a medicine.',
    address: {
      Shanghai: {
        name: 'Shanghai',
        addr: '199 Liangjing Rd, Zhangjiang Hi-Tech Park, Pudong District, Shanghai, China, 201203',
        tel: '+86-21-61097800',
        fax: '+86-21-58387361',
        email: 'info@dizalpharma.com'
      },
      Beijing: {
        name: 'Beijing',
        addr: 'Room 2309, 23 Floor, Tower 2, China Central Place (CCP) Office Building, NO.79 Jianguo Road, Chaoyang District, Beijing 100022',
        tel: '+86-10-87513588',
        fax: '+86-10-58043622'
      },
      Wuxi: {
        name: 'Wuxi',
        addr: 'Room 404, Building C, Huirong Plaza, 26 Hefeng Rd, Xinwu District, Wuxi, Jiangsu, China, 214028 '
      },
      Chengdu: {
        name: 'Chengdu',
        addr: 'Unit 8, 31/F, Yanlord Landmark, No.1, Second Section, Renmin South Road, Jinjiang District, Chengdu, China, 610020'
      }
    }
  },
  see_map: 'See Map',
  terms_of_use: {
    name: 'Terms Of Use',
    content: [
      // 法律声明
      {
        subtitle: 'Legal Declaration',
        intro: [
          {
            dec: 'This website was created and maintained by Dizal Pharmaceutical Co. Ltd. (hereinafter referred to as "Dizal Pharma") . Anyone who enters the website, reads any content, registers for users, downloads any material from the website or uses the information provided by this website, agrees to comply with the following terms. These provisions constitute a agreement between you and Dizal Pharma. Do not use this website if you do not agree to comply with these terms. Dizal Pharma reserves the right to update the following terms at any time without notice, which will also bind you. Dizal Pharma obtains the rights to reject any access and the usage of the website at any time in any case.',
            addition: []
          },
          {
            dec: 'Dizal Pharma reserves the rights of correction, modification and updating this statement at any time.',
            addition: []
          }
        ]
      },
      // 版权声明
      {
        subtitle: 'Copyright Declaration',
        intro: [
          {
            dec: 'Dizal Pharma independently owned the copyright of all information in this website, or jointly own the website copyright with data provider who provides the data on this website or relevant website. Without the express written permission of Dizal Pharma, any person shall not copy or produce server images in non Dizal Pharma server for any content on this website.',
            addition: []
          },
          {
            dec: "The domain name, trademark, content, visual image and sound, figure and pictures contained in this website are protected by relevant trademarks and copyright regulations. Without prior written permission of Dizal Pharma, any enterprise or individual shall not be copied or transmitted in any form. Any unauthorized use of this website will violate the provisions of the copyright law of the People's Republic of China and other relevant laws and regulations, as well as the relevant international conventions.",
            addition: []
          }
        ]
      }
    ]
  },
  privacy_policy: {
    name: 'Privacy Policy',
    content: [
      {
        subtitle: null,
        intro: [
          //   介绍项
          {
            dec: 'This privacy statement applies to all the user of " Dizal Pharma " website (hereinafter referred to as the site). We respect and protect users\' privacy, and solemnly promise that unless we have legal or procedural requirements, we will not publish personal information related to users unless authorized by users. We will regularly check the privacy protection measures to ensure the privacy protection of the user\'s personal data.',
            addition: []
          },
          {
            dec: 'Privacy Notice on Personal Information Protection',
            link: {
              text: 'Notice on Collection, Processing & Cross-border Transfer of Personal Information via 400 Hotline',
              href: 'https://www.dizalpharma.com/static/pdf/400热线个人信息收集处理和出境知情告知.pdf'
            }
          },
          {
            dec: 'In the following exceptions, the foregoing promises will not be guaranteed and the relevant information of the users will be disclosed. These cases included but are not limited to:',
            addition: [
              'when the user on the site in violation of the " Computer Information Network Internet Security, Protection Management Regulations ", "Internet Information Services Management Regulations", or may damage or interfere the rights of other users, the disclosure of personal information of users to identify, contact or take legal action if necessary.',
              'personal information that must be disclosed requested by laws and regulations.',
              'when a judiciary authorities or other authorized institution executes official duties in accordance with the law, it requires the website to publish a specific personal information.'
            ]
          },
          /*{
          dec: "If your information is covered by the General Data Protection Regulation (GDPR), please contact out EU Data Protection Officer (DPO) as follows:",
          addition: [
            "DPO: VeraSafe, LLC",
            "Email: experts@verasafe.com",
            "(1) United States contact information:",
            "Add.:22 Essex Way #8203, Essex, VT 05451 USA",
            "Tel.:+1-617-398-7067",
            "(2) European contact information:",
            "Add.: Klimentská 46, Prague 1, 11002 Czech Republic",
            "Tel.:+1-617-398-7067",
          ]
        },*/
          {
            dec: 'This website has the technical methods and comprehensive security protection system to ensure the maintenance of user privacy data, but this site does not bear any legal responsibility for the user information leaks, damages, losses due to the force majeure, computer virus or hacker attacks and etc.',
            addition: []
          }
        ]
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js